import React from 'react';

import { Grid } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { FeatureBodyCopy } from '../../General/Feature/FeatureBodyCopy';
import { FeatureButton } from '../../General/Feature/FeatureButton';
import { FeatureHeader } from '../../General/Feature/FeatureHeader';
import { FeatureContent } from '../../General/Feature/FeatureContent';
import { FeatureLink } from '../../Marketing/FeatureLink';
import { CtaCard } from '../../General/CtaCard';
import { MobileBodyFeature } from './Mobile/MobileBodyFeature';

export const BodyFeature = ({
  feature,
  accentColor,
  selectedFeature,
  featureRef,
  iosLogo,
  androidLogo,
  qbLogo,
  index,
  special,
  print,
  routing,
  firstSetNoOverview,
  marketing,
  home,
  homeCta,
  cardArray,
  noCards,
}) => {
  const {
    bodyHeader,
    bodySubHeader,
    image,
    videoVariant,
    iosLink,
    qbLink,
    ctaText,
    // svgVariant,
    thumbnailVideoUrl,
    _rawBodyCopy,
    _key,
    ctaLink,
    internalLink,
    links,
  } = feature;

  const lg = useMediaQuery('(max-width: 1280px)');
  const med = useMediaQuery('(max-width: 960px)');

  //ensures the right/left cadence is respected, regardless of how many elements are being passed in the split arrays top and bottom
  const initialIndex =
    cardArray?.findIndex((element) => element._key === feature._key) ?? index;
  return (
    <>
      <Grid
        style={{
          padding: lg
            ? '2rem 0 '
            : noCards
            ? '4rem 0'
            : firstSetNoOverview && index === 0
            ? '0 0 4rem 0'
            : '4rem 0',
        }}
        container
        ref={selectedFeature === _key ? featureRef : null}
        spacing={4}
        justifyContent="space-between"
        alignItems="center"
        direction={initialIndex % 2 === 0 || special ? 'row-reverse' : 'row'}
      >
        <FeatureContent
          image={image}
          thumbnailVideoUrl={thumbnailVideoUrl}
          videoVariant={videoVariant}
        />
        <Grid
          container
          item
          xs={12}
          md={6}
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <FeatureHeader
            print={print}
            bodyHeader={bodyHeader}
            bodySubHeader={bodySubHeader}
            routing={routing}
          />
          <FeatureBodyCopy
            _rawBodyCopy={_rawBodyCopy}
            routing={routing}
            qbLink={qbLink}
            qbLogo={qbLogo}
            marketing={marketing}
          />
          {links?.length ? (
            <Grid container style={{ paddingTop: '2rem' }} spacing={2}>
              {!med
                ? links.map((link, index) => (
                    <FeatureLink link={link} key={index} />
                  ))
                : links.map((link, index) => (
                    <MobileBodyFeature link={link} key={index} />
                  ))}
            </Grid>
          ) : (
            <FeatureButton
              ctaLink={ctaLink}
              internalLink={internalLink}
              iosLink={iosLink}
              qbLink={qbLink}
              ctaText={ctaText}
              routing={routing}
              accentColor={accentColor}
              marketing={marketing}
            />
          )}
        </Grid>
      </Grid>
      {home && index === 0 && homeCta?.ctaHeader ? (
        <CtaCard
          background={homeCta.ctaBackground}
          header={homeCta.ctaHeader}
          subheader={homeCta.ctaSubheader}
          ctaText={homeCta.ctaText}
          ctaLink={homeCta.ctaLink}
          internalLink={homeCta.internalLink}
        />
      ) : null}
    </>
  );
};
